import React from 'react';
import { Box, Container, Grid, Typography, Paper, Stack } from '@mui/material';

type PublisherBenefitsProps = {
  cardBackgroundColor?: string;
};

const PublisherBenefits: React.FC<PublisherBenefitsProps> = ({ cardBackgroundColor = '#fff' }) => {
  const benefits = [
    {
      title: 'Showcase Innovation',
      description:
        'Share your AI agents with a global audience to demonstrate the art of possibilities highlight your expertise and inspire both internal teams and external customers.',
    },
    {
      title: 'Empower Customization',
      description:
        'Allow users to easily download your agents and integrate them into their own environments, empowering them to customize and extend your solutions for diverse real-world applications.',
    },
    {
      title: 'Foster Community Learning',
      description: 'Connect with a vibrant network of AI enthusiasts and professionals, SMEs, exchanging feedback, best practices, and new ideas to continually improve your agents.',
    },
  ];

  return (
    <Box sx={{ py: 8, backgroundColor: '#f8f9fa' }}>
      <Container maxWidth="lg">
        <Typography variant="h4" fontWeight={700} textAlign="center" sx={{ mb: 1 }}>
          Publish. Share. Inspire
        </Typography>
        <Box
          sx={{
            width: 60,
            height: 4,
            backgroundColor: '#1976d2',
            borderRadius: 2,
            mx: 'auto',
            mb: 5,
          }}
        />
        <Box>
          <Grid container spacing={4} justifyContent="center">
            {benefits.map((benefit, index) => (
              <Grid key={index}>
                <Paper
                  elevation={2}
                  sx={{
                    textAlign: 'center',
                    p: 3,
                    borderRadius: '1rem',
                    boxShadow: 3,
                    backgroundColor: cardBackgroundColor,
                    maxWidth: '210px',
                    minHeight: '230px',
                    transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                    '&:hover': {
                      transform: 'translateY(-5px)',
                      boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.08)',
                    },
                  }}
                >
                  <Stack spacing={2} alignContent="center" alignItems="center">
                    
                    <Typography variant="h6" component="h3" sx={{ fontWeight: 600, mb: 1 }}>
                      {benefit.title}
                    </Typography>
                    <Typography variant="body2" color="textSecondary">
                      {benefit.description}
                    </Typography>
                  </Stack>
                </Paper>
              </Grid>
            ))}
          </Grid>
        </Box>
      </Container>
    </Box>
  );
};

export default PublisherBenefits;
